import { render, staticRenderFns } from "./BTableScheduler.vue?vue&type=template&id=04866d96&"
import script from "./BTableScheduler.vue?vue&type=script&lang=js&"
export * from "./BTableScheduler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports